import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class KnowledgebaseListPage extends Component<KnowledgebaseListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.knowledgebase.list }}
                pages={{
                    entity: InferenceEntities.knowledgebase(this.props),
                    list: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}